import axios from 'axios';
import { APP_CONFIG } from '../utils/constants';

// Global request timeout for EVERY axios instance.
//
// There is no shared axios client — 37 service files each call axios.create(),
// and all but one set no `timeout`, so axios falls back to its default of 0 =
// "wait forever". A backend that accepts the connection but never responds
// (slow query, hung proxy, locked DB) then leaves the screen on a spinner that
// never clears, with no error — app-wide.
//
// Setting axios.defaults.timeout BEFORE any service module runs axios.create()
// makes every instance inherit this value; an instance that sets its own
// timeout (authService) keeps it. This module is imported FIRST in src/index.js
// so it runs before the service modules are loaded.
axios.defaults.timeout = APP_CONFIG.REQUEST_TIMEOUT;

export default axios;
